module.exports = __webpack_public_path__ + "static/media/gif.055c5773.gif";